import React, { FC } from 'react'

// MUI
import { Box, CardMedia, Container, Grid, Typography } from '@mui/material'

// Data
import { ServicesData } from '@/data'

// UI
import { DividerLine, PaddTwentyFour } from '@/ui'
import { CardMedDiv, OurServicesH2, ServiceDataDiv, ServiceDescP, ServicesNameH3 } from './styles'

const OurServicesSection: FC = () => {
  return (
    <Box>
      <Container maxWidth="xl">
        <PaddTwentyFour>
          <Box component="section" sx={{ textAlign: 'center' }}>
            <OurServicesH2>
              <Typography variant="body2" variantMapping={{ body2: 'span' }} className="firstHeadline">
                Our
              </Typography>{' '}
              <Typography variant="body2" variantMapping={{ body2: 'span' }} className="secondHeadline">
                Services
              </Typography>
            </OurServicesH2>

            <DividerLine />
          </Box>

          <Box sx={{ py: 10 }}>
            <Grid container alignItems="center" spacing={4}>
              {ServicesData.map((data, idx) => {
                return (
                  <Grid item xs={12} sm={6} md={4} key={idx}>
                    <ServiceDataDiv>
                      <CardMedDiv>
                        <CardMedia component="img" src={data.imgPath} alt={data.title} title={data.title} loading="lazy" />
                      </CardMedDiv>

                      <ServicesNameH3>{data.title}</ServicesNameH3>
                      <ServiceDescP>{data.desc}</ServiceDescP>
                    </ServiceDataDiv>
                  </Grid>
                )
              })}
            </Grid>
          </Box>
        </PaddTwentyFour>
      </Container>
    </Box>
  )
}

export default OurServicesSection
